import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Grid, TextField, Button, Switch, RadioGroup, FormControlLabel, Radio, FormControl, IconButton, Tooltip, Autocomplete, Dialog, DialogTitle, DialogContent, Checkbox } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import CloseIcon from "@mui/icons-material/Close";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import "./SSOSettings.css";
import { API_URL } from "../../config";
import { useEffect, useMemo, useRef, useState } from "react";
import { getGroupSettingsData } from "../../actions/Users/authenticateGroupSettings";
import { saveSSOConfig, updateSSOConfig, deleteSSOConfig, verifySSOConnection, setSSOCode } from "../../actions/Users/authenticateSSOSettings";
import { encode } from "../../utils/encrypt";
import { allTemplate } from "../../actions/Users/authenticate";
import { fetchStarlinkTosValidation } from "../StarlinkToS/slice";
import { filterTemplatesByCapability, isTemplateOptionDisabled, isStarlinkOnlyUser, READ_ACCESS } from "../../utils/templateUtils";
import _ from "lodash";
import { toast } from "react-toastify";
import ConfirmDialog from "../../components/ConfirmDialog";
import { CONFIRM_DIALOG_TITLE } from "../../config";
import CustomLoader from "../Loader/CustomLoaders";

const OktaIcon = () => (
    <svg className="idp-icon" viewBox="0 0 24 24" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 0C5.389 0 0 5.389 0 12s5.389 12 12 12 12-5.389 12-12S18.611 0 12 0zm0 18c-3.314 0-6-2.686-6-6s2.686-6 6-6 6 2.686 6 6-2.686 6-6 6z"
            fill="#007DC1"
        />
    </svg>
);

const AzureIcon = () => (
    <svg className="idp-icon" viewBox="0 0 96 96" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <linearGradient id="sso-azure-a" x1="42.828" y1="12.688" x2="15.787" y2="92.574" gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#114a8b" />
                <stop offset="1" stopColor="#0669bc" />
            </linearGradient>
            <linearGradient id="sso-azure-b" x1="51.275" y1="49.917" x2="45.02" y2="52.032" gradientUnits="userSpaceOnUse">
                <stop offset="0" stopOpacity=".3" />
                <stop offset=".071" stopOpacity=".2" />
                <stop offset=".321" stopOpacity=".1" />
                <stop offset=".623" stopOpacity=".05" />
                <stop offset="1" stopOpacity="0" />
            </linearGradient>
            <linearGradient id="sso-azure-c" x1="47.835" y1="10.358" x2="77.518" y2="89.439" gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#3ccbf4" />
                <stop offset="1" stopColor="#2892df" />
            </linearGradient>
        </defs>
        <path fill="url(#sso-azure-a)" d="M33.338 6.544h26.038l-27.03 80.087a4.152 4.152 0 0 1-3.933 2.824H8.149a4.145 4.145 0 0 1-3.928-5.47L29.404 9.368a4.152 4.152 0 0 1 3.934-2.825z" />
        <path fill="#0078d4" d="M71.175 60.261h-41.29a1.911 1.911 0 0 0-1.305 3.309l26.532 24.764a4.171 4.171 0 0 0 2.846 1.121h23.38z" />
        <path fill="url(#sso-azure-b)" d="M33.338 6.544a4.118 4.118 0 0 0-3.943 2.879L4.252 83.917a4.14 4.14 0 0 0 3.908 5.538h20.787a4.443 4.443 0 0 0 3.41-2.9l5.014-14.777 17.91 16.705a4.237 4.237 0 0 0 2.666.972H81.24L71.024 60.261l-29.781.007L59.47 6.544z" />
        <path fill="url(#sso-azure-c)" d="M66.595 9.364a4.145 4.145 0 0 0-3.928-2.82H33.648a4.146 4.146 0 0 1 3.928 2.82l25.184 74.62a4.146 4.146 0 0 1-3.928 5.472h29.02a4.146 4.146 0 0 0 3.927-5.472z" />
    </svg>
);

const SSOSettings = (props) => {
    const {
        authReducer, errorReducer, getGroupSettingsData, saveSSOConfig, updateSSOConfig, deleteSSOConfig, verifySSOConnection, setSSOCode,
        allTemplate, fetchStarlinkTosValidation, tosAccepted,
        selectedOu, groupSettingsdata, saveSSOConfigData, updateSSOConfigData, deleteSSOConfigData, verifySSOConnectionData, setSSOCodeData
    } = props;

    // Form fields
    const [idpType, setIdpType] = useState("");
    const [ssoIdpSsoUrl, setSsoIdpSsoUrl] = useState("");
    const [hasIdpSsoUrl, setHasIdpSsoUrl] = useState(false);
    const [ssoIdpEntityId, setSsoIdpEntityId] = useState("");
    const [hasIdpEntityId, setHasIdpEntityId] = useState(false);
    const [ssoIdpCertificate, setSsoIdpCertificate] = useState("");
    const [hasCertificate, setHasCertificate] = useState(false);
    const [ssoInheritToSubDp, setSsoInheritToSubDp] = useState(false);
    const [ssoPurgeInterval, setSsoPurgeInterval] = useState<number>(30);

    // Group Role Mapping
    const [groupRoleMapping, setGroupRoleMapping] = useState<{ idpGroup: string; accessLevel: string }[]>([]);

    // Default Policy Template selectors
    const [templateName, setTemplateName] = useState<string[]>([]);
    const [denyIfUnmatched, setDenyIfUnmatched] = useState(false);

    // Available options (populated from API)
    const [templateNames, setTemplateNames] = useState<string[]>([]);

    // Read-only fields (populated from API responses)
    const [ssoSpEntityId, setSsoSpEntityId] = useState("");
    const [ssoAcsUrl, setSsoAcsUrl] = useState("");
    const [ssoConnectionStatus, setSsoConnectionStatus] = useState("");

    // SSO Organization ID
    const [ssoCode, setSsoCodeState] = useState("");
    const [savedSsoCode, setSavedSsoCode] = useState(""); // reflects only saved value
    const sportDomain = groupSettingsdata?.data?.sportDomain;
    const portalBaseUrl = sportDomain ? `https://${sportDomain}` : window.location.origin;
    const [isSavingCode, setIsSavingCode] = useState(false);
    const [ssoCodeError, setSsoCodeError] = useState("");

    // Inheritance state
    const [isInherited, setIsInherited] = useState(false);
    const [sourceDpId, setSourceDpId] = useState("");
    const [sourceDpName, setSourceDpName] = useState("");

    // UI state
    const [userAttributeGuideOpen, setUserAttributeGuideOpen] = useState(false);
    const [isConfigured, setIsConfigured] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [isConfigLoading, setIsConfigLoading] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [loaderMessage, setLoaderMessage] = useState("Loading SSO configuration...");
    const [isVerifying, setIsVerifying] = useState(false);
    const ssoLoadingRef = useRef(false);
    const [validationErrors, setValidationErrors] = useState<Record<string, string>>({});
    const [confirmDialog, setConfirmDialog] = useState({
        isOpen: false,
        title: "",
        subTitle: "",
        onConfirm: () => {},
    });

    const filteredTemplateNames = useMemo(
        () => filterTemplatesByCapability(templateNames, tosAccepted, isStarlinkOnlyUser()),
        [templateNames, tosAccepted]
    );

    const isReadOnly = isConfigured && !isEditing;

    const computedSpEntityId = selectedOu?.id ? `KN-${selectedOu.id.replace(/-/g, "")}-SSO` : "";
    const computedAcsUrl = `${API_URL}/iam/idp/wso2/commonauth`;
    const displaySpEntityId = ssoSpEntityId || computedSpEntityId;
    const displayAcsUrl = ssoAcsUrl || computedAcsUrl;

    // Load data when OU changes
    useEffect(() => {
        if (!_.isEmpty(selectedOu) && selectedOu?.id) {
            setLoaderMessage("Loading SSO configuration...");
            setIsConfigLoading(true);
            ssoLoadingRef.current = true;
            setSsoCodeState("");
            setSavedSsoCode("");
            setSsoCodeError("");
            setIsEditing(false);
            getGroupSettingsData(selectedOu.id);
            allTemplate(selectedOu.name, true);
            fetchStarlinkTosValidation(selectedOu.id);
        }
    }, [selectedOu]);

    // Process fetched templates into options
    useEffect(() => {
        if (!_.isEmpty(authReducer.allTemplate)) {
            const templateRecords = authReducer.allTemplate.data;
            const allNames: string[] = templateRecords.map((t: any) => t.name);

            const fullAccessIdx = allNames.indexOf("Full Access");
            if (fullAccessIdx > 0) {
                allNames.splice(fullAccessIdx, 1);
                allNames.unshift("Full Access");
            }
            setTemplateNames(allNames);

            authReducer.allTemplate = {};
        }
    }, [authReducer.allTemplate]);

    // Auto-select Read Access for new SSO configs
    useEffect(() => {
        if (!isConfigured && !denyIfUnmatched && templateName.length === 0 && filteredTemplateNames.includes(READ_ACCESS)) {
            setTemplateName([READ_ACCESS]);
        }
    }, [filteredTemplateNames, isConfigured, denyIfUnmatched]);

    const populateFromConfig = (sso: any) => {
        setIsInherited(sso.inherited === true);
        setSourceDpId(sso.sourceDpId || "");
        setSourceDpName(sso.sourceDpName || "");
        setSsoCodeState(sso.ssoCode || "");
        setSavedSsoCode(sso.ssoCode || "");
        ssoLoadingRef.current = false;
        setIsConfigLoading(false);
        setSsoConnectionStatus(sso.ssoConnectionStatus || "");
        setSsoAcsUrl(sso.acsUrl || sso.ssoAcsUrl || "");
        setValidationErrors({});

        if (sso.inherited === true) {
            // Inherited: no own config — leave IdP fields empty so admin can configure own SSO
            setIsConfigured(false);
            setIdpType("");
            setSsoIdpSsoUrl("");
            setHasIdpSsoUrl(false);
            setSsoIdpEntityId("");
            setHasIdpEntityId(false);
            setSsoIdpCertificate("");
            setHasCertificate(false);
            setSsoPurgeInterval(30);
            setSsoInheritToSubDp(false);
            setSsoSpEntityId("");
            setTemplateName([]);
            setDenyIfUnmatched(false);
            setGroupRoleMapping([]);
            return;
        }

        setIsConfigured(true);
        setIdpType(sso.idpType || "");
        setSsoIdpSsoUrl(""); // API no longer returns the value
        setHasIdpSsoUrl(sso.hasIdpSsoUrl === true);
        setSsoIdpEntityId(""); // API no longer returns the value
        setHasIdpEntityId(sso.hasIdpEntityId === true);
        setSsoIdpCertificate(""); // API no longer returns the value
        setHasCertificate(sso.hasIdpCertificate === true);
        setSsoPurgeInterval(sso.ssoPurgeInterval || 30);
        setSsoInheritToSubDp(sso.ssoInheritToSubDp || false);
        setSsoSpEntityId(sso.ssoSpEntityId || "");

        if (sso.ssoDefaultTemplates?.length > 0) {
            setTemplateName(sso.ssoDefaultTemplates);
            setDenyIfUnmatched(false);
        } else {
            setTemplateName([]);
            setDenyIfUnmatched(true);
        }
        setGroupRoleMapping(sso.ssoGroupRoleMapping || []);
    };

    // Populate form from fetched SSO config data
    useEffect(() => {
        if (!_.isEmpty(groupSettingsdata)) {
            const sso = groupSettingsdata?.data?.ssoConfig;
            if (sso) {
                populateFromConfig(sso);
            } else {
                resetForm();
                setSsoCodeState(selectedOu?.id || "");
                setSavedSsoCode(selectedOu?.id || "");
                if (filteredTemplateNames.includes(READ_ACCESS)) {
                    setTemplateName([READ_ACCESS]);
                }
            }
        }
    }, [groupSettingsdata]);

    // Handle save response
    useEffect(() => {
        if (!_.isEmpty(saveSSOConfigData)) {
            setShowLoader(false);
            if (saveSSOConfigData?.success) {
                toast.success("SSO configuration saved successfully", {
                    position: toast.POSITION.BOTTOM_LEFT,
                });
                if (saveSSOConfigData?.data?.acsUrl) {
                    setSsoAcsUrl(saveSSOConfigData.data.acsUrl);
                }
                if (saveSSOConfigData?.data?.spEntityId) {
                    setSsoSpEntityId(saveSSOConfigData.data.spEntityId);
                }
                authReducer.saveSSOConfig = {};
                getGroupSettingsData(selectedOu.id);
            } else if (saveSSOConfigData?.errors) {
                const errMsg = Array.isArray(saveSSOConfigData.errors)
                    ? saveSSOConfigData.errors.map((e: { message?: string }) => e.message).join(", ")
                    : String(saveSSOConfigData.errors);
                toast.error(errMsg || "Failed to save SSO configuration", {
                    position: toast.POSITION.BOTTOM_LEFT,
                });
                authReducer.saveSSOConfig = {};
            }
        }
    }, [saveSSOConfigData]);

    // Handle update response
    useEffect(() => {
        if (!_.isEmpty(updateSSOConfigData)) {
            setShowLoader(false);
            if (updateSSOConfigData?.success) {
                toast.success("SSO configuration updated successfully", {
                    position: toast.POSITION.BOTTOM_LEFT,
                });
                if (updateSSOConfigData?.data?.acsUrl) {
                    setSsoAcsUrl(updateSSOConfigData.data.acsUrl);
                }
                if (updateSSOConfigData?.data?.spEntityId) {
                    setSsoSpEntityId(updateSSOConfigData.data.spEntityId);
                }
                setIsEditing(false);
                authReducer.updateSSOConfig = {};
                getGroupSettingsData(selectedOu.id);
            } else if (updateSSOConfigData?.errors) {
                const errMsg = Array.isArray(updateSSOConfigData.errors)
                    ? updateSSOConfigData.errors.map((e: { message?: string }) => e.message).join(", ")
                    : String(updateSSOConfigData.errors);
                toast.error(errMsg || "Failed to update SSO configuration", {
                    position: toast.POSITION.BOTTOM_LEFT,
                });
                authReducer.updateSSOConfig = {};
            }
        }
    }, [updateSSOConfigData]);

    // Handle delete response
    useEffect(() => {
        if (!_.isEmpty(deleteSSOConfigData)) {
            setShowLoader(false);
            if (deleteSSOConfigData?.success) {
                toast.success("SSO configuration deleted successfully", {
                    position: toast.POSITION.BOTTOM_LEFT,
                });
                authReducer.deleteSSOConfig = {};
                resetForm();
                getGroupSettingsData(selectedOu.id);
            } else if (deleteSSOConfigData?.errors) {
                const errMsg = Array.isArray(deleteSSOConfigData.errors)
                    ? deleteSSOConfigData.errors.map((e: { message?: string }) => e.message).join(", ")
                    : String(deleteSSOConfigData.errors);
                toast.error(errMsg || "Failed to delete SSO configuration", {
                    position: toast.POSITION.BOTTOM_LEFT,
                });
                authReducer.deleteSSOConfig = {};
            }
        }
    }, [deleteSSOConfigData]);

    // Handle verify response
    useEffect(() => {
        if (!_.isEmpty(verifySSOConnectionData)) {
            setIsVerifying(false);
            setShowLoader(false);
            if (verifySSOConnectionData?.success) {
                const newStatus = verifySSOConnectionData?.data?.connectionStatus || "PENDING";
                setSsoConnectionStatus(newStatus);
                if (newStatus === "ACTIVE") {
                    toast.success("SSO connection verified successfully", {
                        position: toast.POSITION.BOTTOM_LEFT,
                    });
                } else {
                    const statusMessages: Record<string, string> = {
                        PENDING: "SSO connection verification is still in progress. Please wait a moment and try again.",
                        FAILED: "SSO connection verification failed. Please review your configuration and try again.",
                        INACTIVE: "SSO connection is inactive. Please review your configuration and try again.",
                    };
                    const friendlyMessage = statusMessages[newStatus]
                        || "SSO connection could not be verified. Please review your configuration and try again.";
                    toast.warn(friendlyMessage, {
                        position: toast.POSITION.BOTTOM_LEFT,
                    });
                }
                authReducer.verifySSOConnection = {};
            } else if (verifySSOConnectionData?.errors) {
                const errMsg = Array.isArray(verifySSOConnectionData.errors)
                    ? verifySSOConnectionData.errors.map((e: { message?: string }) => e.message).join(", ")
                    : String(verifySSOConnectionData.errors);
                toast.error(errMsg || "Failed to verify SSO connection", {
                    position: toast.POSITION.BOTTOM_LEFT,
                });
                authReducer.verifySSOConnection = {};
            }
        }
    }, [verifySSOConnectionData]);

    // Handle setSSOCode response (for inherited DPs setting their own code)
    useEffect(() => {
        if (!_.isEmpty(setSSOCodeData)) {
            setIsSavingCode(false);
            if (setSSOCodeData?.success) {
                setSavedSsoCode(ssoCode.trim());
                toast.success("SSO Organization ID saved successfully", { position: toast.POSITION.BOTTOM_LEFT });
            } else if (setSSOCodeData?.errors) {
                const errMsg = Array.isArray(setSSOCodeData.errors)
                    ? setSSOCodeData.errors.map((e: { message?: string }) => e.message).join(", ")
                    : String(setSSOCodeData.errors);
                toast.error(errMsg || "Failed to save SSO Organization ID", { position: toast.POSITION.BOTTOM_LEFT });
            }
            authReducer.setSSOCode = {};
        }
    }, [setSSOCodeData]);

    // Handle API errors (dispatched to errorReducer by handleResponse for non-200 responses)
    useEffect(() => {
        if (!_.isEmpty(errorReducer?.error)) {
            if (ssoLoadingRef.current) {
                ssoLoadingRef.current = false;
                setIsConfigLoading(false);
            }
        }
        if ((showLoader || isVerifying) && !_.isEmpty(errorReducer?.error)) {
            setShowLoader(false);
            setIsVerifying(false);
            const errData = errorReducer.error;
            const rawMessage = errData?.data?.errors || errData?.data?.message || errData?.message || "";
            // Show a user-friendly message for generic HTTP errors
            const isGenericHttpError = typeof rawMessage === "string" && rawMessage.includes("Request failed with status code");
            const message = (!rawMessage || isGenericHttpError)
                ? "Failed to process SSO configuration. Please try again or contact support if the issue persists."
                : rawMessage;
            toast.error(message, {
                position: toast.POSITION.BOTTOM_LEFT,
            });
        }
    }, [errorReducer?.error]);

    const resetForm = () => {
        setIsConfigured(false);
        setIsEditing(false);
        ssoLoadingRef.current = false;
        setIsConfigLoading(false);
        setIdpType("");
        setSsoIdpSsoUrl("");
        setHasIdpSsoUrl(false);
        setSsoIdpEntityId("");
        setHasIdpEntityId(false);
        setSsoIdpCertificate("");
        setHasCertificate(false);
        setSsoInheritToSubDp(false);
        setSsoPurgeInterval(30);
        setTemplateName([]);
        setDenyIfUnmatched(false);
        setGroupRoleMapping([]);
        setSsoSpEntityId("");
        setSsoAcsUrl("");
        setSsoConnectionStatus("");
        setValidationErrors({});
        setIsInherited(false);
        setSourceDpId("");
        setSourceDpName("");
        setSsoCodeState("");
    };

    const isValidUrl = (str: string): boolean => {
        try { new URL(str); return true; } catch { return false; }
    };

    const isValidCertificate = (cert: string): boolean => {
        const stripped = cert
            .replace(/-----BEGIN CERTIFICATE-----/g, "")
            .replace(/-----END CERTIFICATE-----/g, "")
            .replace(/\s/g, "");
        return /^[A-Za-z0-9+/=]+$/.test(stripped) && stripped.length >= 100;
    };

    const validate = (): boolean => {
        const errors: Record<string, string> = {};
        if (!idpType) errors.idpType = "Identity Provider is required";
        if (!hasIdpSsoUrl && !ssoIdpSsoUrl.trim()) {
            errors.ssoIdpSsoUrl = "SSO URL is required";
        } else if (ssoIdpSsoUrl.trim() && !isValidUrl(ssoIdpSsoUrl.trim())) {
            errors.ssoIdpSsoUrl = "Please enter a valid URL (e.g. https://your-idp.com/...)";
        }
        if (!hasIdpEntityId && !ssoIdpEntityId.trim()) {
            errors.ssoIdpEntityId = "Identity Provider Entity ID is required";
        } else if (ssoIdpEntityId.trim() && !isValidUrl(ssoIdpEntityId.trim())) {
            errors.ssoIdpEntityId = "Please enter a valid URL (e.g. https://your-idp.com/entity-id)";
        }
        if (!hasCertificate && !ssoIdpCertificate.trim()) {
            errors.ssoIdpCertificate = "Identity Provider Certificate is required";
        } else if (ssoIdpCertificate.trim() && !isValidCertificate(ssoIdpCertificate)) {
            errors.ssoIdpCertificate = "Please enter a valid certificate";
        }
        if (!denyIfUnmatched && templateName.length === 0) {
            errors.defaultPolicy = "Select at least one access level, or check 'Deny access to unmatched users'.";
        }
        setValidationErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const buildPayload = () => {
        const payload: any = {
            dpId: selectedOu.id,
            idpType,
            ssoProtocol: "SAML",
            ssoInheritToSubDp,
            ssoPurgeInterval: ssoPurgeInterval || 30,
            // Empty array is intentional when denyIfUnmatched is true — backend interprets [] as "deny unmatched users"
            ssoDefaultTemplates: templateName,
            ssoGroupRoleMapping: groupRoleMapping.filter((m) => m.idpGroup && m.accessLevel),
        };
        // Only include sensitive fields if the user entered a new value; omitting tells backend to keep existing
        if (ssoIdpSsoUrl.trim()) payload.ssoIdpSsoUrl = ssoIdpSsoUrl.trim();
        if (ssoIdpEntityId.trim()) payload.ssoIdpEntityId = ssoIdpEntityId.trim();
        if (ssoIdpCertificate.trim()) payload.ssoIdpCertificate = ssoIdpCertificate.trim();
        return payload;
    };

    const handleSave = () => {
        if (!validate()) return;
        const confirmMessage = ssoInheritToSubDp
            ? "Are you sure you want to save? This SSO configuration will apply to this organization and all sub-organizations. Any SSO configuration that is currently set up on sub-organizations will be removed."
            : "Are you sure you want to save? This SSO configuration will apply to this organization only. Sub-organizations will not be affected.";
        setConfirmDialog({
            isOpen: true,
            title: CONFIRM_DIALOG_TITLE,
            subTitle: confirmMessage,
            onConfirm: () => {
                setLoaderMessage(isConfigured ? "Updating SSO configuration..." : "Saving SSO configuration...");
                setShowLoader(true);
                const payload = buildPayload();
                if (isConfigured) {
                    updateSSOConfig(payload);
                } else {
                    saveSSOConfig(payload);
                }
            },
        });
    };

    const handleClear = () => {
        setConfirmDialog({
            isOpen: true,
            title: CONFIRM_DIALOG_TITLE,
            subTitle: "This will remove all SSO configuration for this organization. Are you sure?",
            onConfirm: () => {
                setLoaderMessage("Removing SSO configuration...");
                setShowLoader(true);
                deleteSSOConfig(selectedOu.id);
            },
        });
    };

    const handleEdit = () => {
        setIsEditing(true);
    };

    const handleCancel = () => {
        const sso = groupSettingsdata?.data?.ssoConfig;
        if (sso) {
            populateFromConfig(sso);
        }
        setIsEditing(false);
    };

    const handleVerifyConnection = () => {
        setLoaderMessage("Verifying SSO connection...");
        setIsVerifying(true);
        setShowLoader(true);
        verifySSOConnection(selectedOu.id);
    };

    const handleCopyToClipboard = (text: string) => {
        navigator.clipboard.writeText(text);
        toast.info("Copied to clipboard", {
            position: toast.POSITION.BOTTOM_LEFT,
        });
    };

    const ssoCodeRegex = /^[a-zA-Z0-9 \-_]{4,12}$/;

    const validateSsoCode = (code: string): string => {
        const trimmed = code.trim();
        if (!trimmed) return "SSO Organization ID is required";
        if (trimmed.length < 4) return "SSO Organization ID must be at least 4 characters";
        if (trimmed.length > 12) return "SSO Organization ID must be at most 12 characters";
        if (!ssoCodeRegex.test(trimmed)) return "Only letters, numbers, spaces, hyphens and underscores are allowed";
        return "";
    };

    const handleSaveCode = () => {
        const error = validateSsoCode(ssoCode);
        if (error) { setSsoCodeError(error); return; }
        setSsoCodeError("");
        setIsSavingCode(true);
        setSSOCode({ dpId: selectedOu.id, ssoCode: ssoCode.trim() });
    };

    const handlePurgeIntervalChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const val = Number(e.target.value);
        if (val >= 1 && val <= 365) {
            setSsoPurgeInterval(val);
        }
    };

    const addGroupMapping = () => {
        setGroupRoleMapping([...groupRoleMapping, { idpGroup: "", accessLevel: "" }]);
    };

    const removeGroupMapping = (index: number) => {
        setGroupRoleMapping(groupRoleMapping.filter((_, i) => i !== index));
    };

    const updateGroupMapping = (index: number, field: "idpGroup" | "accessLevel", value: string) => {
        const updated = [...groupRoleMapping];
        updated[index] = { ...updated[index], [field]: value };
        setGroupRoleMapping(updated);
    };

    const clearValidationError = (field: string) => {
        if (validationErrors[field]) {
            setValidationErrors((prev) => {
                const next = { ...prev };
                delete next[field];
                return next;
            });
        }
    };

    return (
        <Grid>
            <Grid className="sso-settings">
                <div className="sso-settings-form">
                    <div className="sso-header-row">
                        <div className="sso-section-title">SSO Configuration</div>
                        {isConfigured && (
                            <div className="sso-status-indicator">
                                <span className={`sso-status-dot status-dot-${ssoConnectionStatus || "PENDING"}`} />
                                <span className={`sso-status-text status-text-${ssoConnectionStatus || "PENDING"}`}>
                                    {ssoConnectionStatus === "ACTIVE" ? "Active" : ssoConnectionStatus === "FAILED" ? "Inactive" : "Pending"}
                                </span>
                                {!isInherited && (
                                    <Tooltip title="Run a verification check on the SSO connection to confirm it is properly configured and reachable.">
                                        <Button
                                            className="sso-verify-button"
                                            size="small"
                                            onClick={handleVerifyConnection}
                                            disabled={isVerifying}
                                        >
                                            {isVerifying ? "Verifying..." : "Verify Connection"}
                                        </Button>
                                    </Tooltip>
                                )}
                            </div>
                        )}
                    </div>

                    {isInherited && (
                        <div className="sso-inherited-banner">
                            <InfoOutlinedIcon className="sso-inherited-icon" />
                            <span>
                                SSO is currently configured and managed by <strong>{sourceDpName}</strong>. Your users can already log in using SSO.
                                You can set your SSO Organization ID below for the login page, or configure your own SSO to use a different Identity Provider.
                            </span>
                        </div>
                    )}

                    {/* Service Provider Details - always visible */}
                    <div className="sso-step-title">Service Provider Details</div>
                    <div className="sso-sp-note-banner">
                        <InfoOutlinedIcon className="sso-sp-banner-icon" />
                        <span>Use the values below to complete the SAML setup in your Identity Provider. The ACS URL must be configured as the Reply URL (Assertion Consumer Service endpoint) in your IdP's SAML application settings.</span>
                    </div>
                    <div className="sso-form-row">
                        <span className="sso-label">SP Entity ID</span>
                        <div className="sso-field">
                            <span className="sso-readonly-value">
                                {displaySpEntityId}
                                <Tooltip title="Copy SP Entity ID">
                                    <IconButton className="sso-copy-btn" size="small" onClick={() => handleCopyToClipboard(displaySpEntityId)}>
                                        <ContentCopyIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            </span>
                        </div>
                    </div>
                    <div className="sso-form-row">
                        <span className="sso-label">ACS URL</span>
                        <div className="sso-field">
                            <span className="sso-readonly-value">
                                {displayAcsUrl}
                                <Tooltip title="Copy ACS URL to configure in your Identity Provider">
                                    <IconButton className="sso-copy-btn" size="small" onClick={() => handleCopyToClipboard(displayAcsUrl)}>
                                        <ContentCopyIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            </span>
                        </div>
                    </div>

                    {/* SSO Organization ID */}
                    <div className="sso-form-row">
                        <span className="sso-label">
                            SSO Organization ID
                            <Tooltip title={<span>A short ID that users enter to identify your organization on the SSO login page. Defaults to your organization ID - you can change it to something more memorable.<br />• Must be 4–12 characters<br />• Allowed: letters, numbers, spaces, hyphens (-) and underscores (_)</span>}>
                                <InfoOutlinedIcon className="sso-info-icon" />
                            </Tooltip>
                        </span>
                        <div className="sso-field">
                            <div className="sso-code-inline">
                                <TextField
                                    size="small"
                                    variant="outlined"
                                    placeholder={isConfigLoading ? "Enter SSO Organization ID" : (selectedOu?.id || "Enter SSO Organization ID")}
                                    value={ssoCode}
                                    onChange={(e) => { setSsoCodeState(e.target.value); setSsoCodeError(""); }}
                                    inputProps={{ maxLength: 12 }}
                                    error={!!ssoCodeError}
                                    helperText={ssoCodeError}
                                />
                                <Button
                                    size="small"
                                    className="sso-save-button"
                                    onClick={handleSaveCode}
                                    disabled={isSavingCode || isConfigLoading || !ssoCode.trim() || ssoCode.trim() === savedSsoCode}
                                >
                                    {isSavingCode ? "Saving..." : "Save"}
                                </Button>
                            </div>
                        </div>
                    </div>

                    {/* Login URL */}
                    <div className="sso-form-row">
                        <span className="sso-label">
                            Portal URL
                            <Tooltip title="Please share this URL with your users, enabling direct SSO sign-in once setup is complete.">
                                <InfoOutlinedIcon className="sso-info-icon" />
                            </Tooltip>
                        </span>
                        <div className="sso-field">
                            {!isConfigLoading && (
                            <span className="sso-readonly-value sso-portal-url-value">
                                {(() => {
                                    const code = savedSsoCode.trim() || selectedOu?.id || "";
                                    const url = `${portalBaseUrl}/sso?code=${encode(code)}`;
                                    return <>
                                        <Tooltip title={url}>
                                            <span className="sso-portal-url-text">{url}</span>
                                        </Tooltip>
                                        <Tooltip title="Copy Portal URL">
                                            <IconButton className="sso-copy-btn" size="small" onClick={() => handleCopyToClipboard(url)}>
                                                <ContentCopyIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    </>;
                                })()}
                            </span>
                            )}
                        </div>
                    </div>

                    {/* Identity Provider Configuration */}
                    <div className="sso-step-title sso-step-divider">Identity Provider Configuration</div>

                    {/* IdP Type Radio Selector */}
                    <div className="sso-form-row">
                        <span className="sso-label">
                            Identity Provider<span className="required-asterisk">*</span>
                        </span>
                        <div className="sso-field">
                            <FormControl component="fieldset">
                                <RadioGroup
                                    row
                                    value={idpType}
                                    onChange={(e) => {
                                        setIdpType(e.target.value);
                                        clearValidationError("idpType");
                                    }}
                                    className="sso-idp-radio-group"
                                >
                                    <FormControlLabel
                                        value="OKTA"
                                        control={<Radio size="small" />}
                                        label={
                                            <span className="sso-idp-radio-label">
                                                <OktaIcon /> Okta
                                            </span>
                                        }
                                        disabled={isConfigured || isInherited}
                                    />
                                    <FormControlLabel
                                        value="AZURE"
                                        control={<Radio size="small" />}
                                        label={
                                            <span className="sso-idp-radio-label">
                                                <AzureIcon /> Azure AD
                                            </span>
                                        }
                                        disabled={isConfigured || isInherited}
                                    />
                                </RadioGroup>
                            </FormControl>
                            {validationErrors.idpType && <div className="sso-field-error">{validationErrors.idpType}</div>}
                        </div>
                    </div>

                    {/* IdP Setup Guide Note - only shown before first save */}
                    {idpType && !isConfigured && (
                        <div className="sso-idp-note-banner">
                            {idpType === "OKTA" ? (
                                <>
                                    To find the SSO URL, Entity ID, and Certificate, go to your Okta Admin Console, open your SAML application, and navigate to the <strong>Sign On</strong> tab. See{" "}
                                    <a href="https://help.okta.com/en-us/content/topics/apps/apps_app_integration_wizard_saml.htm" target="_blank" rel="noopener noreferrer">
                                        Okta SAML setup guide
                                    </a> for detailed instructions.
                                </>
                            ) : (
                                <>
                                    To find the SSO URL, Entity ID, and Certificate, go to your Microsoft Entra ID portal, open your enterprise application's <strong>Single sign-on</strong> settings. See{" "}
                                    <a href="https://learn.microsoft.com/en-us/entra/identity/enterprise-apps/add-application-portal-setup-sso" target="_blank" rel="noopener noreferrer">
                                        Azure AD SAML setup guide
                                    </a> for detailed instructions.
                                </>
                            )}
                        </div>
                    )}

                    {/* Protocol Badge */}
                    <div className="sso-form-row">
                        <span className="sso-label">Protocol</span>
                        <div className="sso-field">
                            <span className="sso-protocol-badge">SAML</span>
                        </div>
                    </div>

                    {/* Required: SSO IdP SSO URL */}
                    <div className="sso-form-row">
                        <span className="sso-label">
                            IdP SSO URL{!isReadOnly && <span className="required-asterisk">*</span>}
                            <Tooltip title="This URL and the other SSO configuration values (Entity ID, Certificate) can be found in your Identity Provider's SAML application settings (e.g., Okta or Azure AD).">
                                <InfoOutlinedIcon className="sso-info-icon" />
                            </Tooltip>
                        </span>
                        <div className="sso-field">
                            {isReadOnly ? (
                                <span className={`sso-configured-badge ${hasIdpSsoUrl ? "configured" : "not-configured"}`}>
                                    {hasIdpSsoUrl ? "Configured" : "Not configured"}
                                </span>
                            ) : (
                                <>
                                    <TextField
                                        size="small"
                                        variant="outlined"
                                        placeholder={hasIdpSsoUrl ? "Leave blank to keep existing URL" : "https://your-idp.com/sso/saml"}
                                        value={ssoIdpSsoUrl}
                                        onChange={(e) => {
                                            setSsoIdpSsoUrl(e.target.value);
                                            clearValidationError("ssoIdpSsoUrl");
                                        }}
                                        error={!!validationErrors.ssoIdpSsoUrl}
                                    />
                                    {validationErrors.ssoIdpSsoUrl && <div className="sso-field-error">{validationErrors.ssoIdpSsoUrl}</div>}
                                </>
                            )}
                        </div>
                    </div>

                    {/* Required: IdP Entity ID */}
                    <div className="sso-form-row">
                        <span className="sso-label">
                            IdP Entity ID{!isReadOnly && <span className="required-asterisk">*</span>}
                        </span>
                        <div className="sso-field">
                            {isReadOnly ? (
                                <span className={`sso-configured-badge ${hasIdpEntityId ? "configured" : "not-configured"}`}>
                                    {hasIdpEntityId ? "Configured" : "Not configured"}
                                </span>
                            ) : (
                                <>
                                    <TextField
                                        size="small"
                                        variant="outlined"
                                        placeholder={hasIdpEntityId ? "Leave blank to keep existing Entity ID" : "https://your-idp.com/entity-id"}
                                        value={ssoIdpEntityId}
                                        onChange={(e) => {
                                            setSsoIdpEntityId(e.target.value);
                                            clearValidationError("ssoIdpEntityId");
                                        }}
                                        error={!!validationErrors.ssoIdpEntityId}
                                    />
                                    {validationErrors.ssoIdpEntityId && <div className="sso-field-error">{validationErrors.ssoIdpEntityId}</div>}
                                </>
                            )}
                        </div>
                    </div>

                    {/* Required: IdP Certificate */}
                    <div className="sso-form-row">
                        <span className="sso-label">
                            IdP Certificate{!isReadOnly && <span className="required-asterisk">*</span>}
                        </span>
                        <div className="sso-field">
                            {isReadOnly ? (
                                <span className={`sso-configured-badge ${hasCertificate ? "configured" : "not-configured"}`}>
                                    {hasCertificate ? "Configured" : "Not configured"}
                                </span>
                            ) : (
                                <>
                                    <TextField
                                        size="small"
                                        variant="outlined"
                                        multiline
                                        rows={4}
                                        placeholder={hasCertificate ? "Leave blank to keep existing certificate" : "Paste Base64 X.509 signing certificate"}
                                        value={ssoIdpCertificate}
                                        onChange={(e) => {
                                            setSsoIdpCertificate(e.target.value);
                                            clearValidationError("ssoIdpCertificate");
                                        }}
                                        error={!!validationErrors.ssoIdpCertificate}
                                    />
                                    {validationErrors.ssoIdpCertificate && <div className="sso-field-error">{validationErrors.ssoIdpCertificate}</div>}
                                </>
                            )}
                        </div>
                    </div>

                    {/* Group Role Mapping (optional) */}
                    <div className="sso-form-row sso-group-mapping-row">
                        <span className="sso-label">
                            Group Role Mapping
                            <Tooltip title="Map Identity Provider groups to access levels. When an SSO user belongs to a mapped IdP group, they will receive the corresponding access level instead of the default policy.">
                                <InfoOutlinedIcon className="sso-info-icon" />
                            </Tooltip>
                        </span>
                        <div className="sso-field">
                            {groupRoleMapping.map((mapping, index) => (
                                <div className="sso-group-mapping-entry" key={index}>
                                    <TextField
                                        size="small"
                                        variant="outlined"
                                        placeholder="IdP Group Name"
                                        value={mapping.idpGroup}
                                        onChange={(e) => updateGroupMapping(index, "idpGroup", e.target.value)}
                                        className="sso-group-mapping-input"
                                        disabled={isReadOnly}
                                    />
                                    <Autocomplete
                                        className="autocompleteText sso-group-mapping-select"
                                        size="small"
                                        value={mapping.accessLevel || null}
                                        options={filteredTemplateNames}
                                        getOptionLabel={(option: any) => option}
                                        isOptionEqualToValue={(option, value) => option === value}
                                        onChange={(_e, newValue: any) => updateGroupMapping(index, "accessLevel", newValue || "")}
                                        disabled={isReadOnly}
                                        renderInput={(params) => (
                                            <TextField {...params} placeholder="Access Level" />
                                        )}
                                    />
                                    {!isReadOnly && (
                                        <IconButton size="small" onClick={() => removeGroupMapping(index)} className="sso-group-mapping-remove">
                                            <RemoveCircleOutlineIcon fontSize="small" />
                                        </IconButton>
                                    )}
                                </div>
                            ))}
                            {!isReadOnly && (
                                <div className="sso-group-mapping-actions">
                                    <Button
                                        size="small"
                                        className="sso-group-mapping-add"
                                        startIcon={<AddCircleOutlineIcon />}
                                        onClick={addGroupMapping}
                                    >
                                        Add Group Mapping
                                    </Button>
                                    <Button
                                        size="small"
                                        className="sso-group-mapping-guide-btn"
                                        startIcon={<HelpOutlineIcon />}
                                        onClick={() => setUserAttributeGuideOpen(true)}
                                    >
                                        How to configure
                                    </Button>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Default Policy Templates - Access Level only */}
                    <div className="sso-form-row sso-policy-row">
                        <span className="sso-label">
                            Default Policy{!denyIfUnmatched && <span className="required-asterisk">*</span>}
                            <Tooltip title="This policy is applied to SSO users who don't already have an IAM account with assigned policies. If the user already exists in IAM, their existing policies will be used instead.">
                                <InfoOutlinedIcon className="sso-info-icon" />
                            </Tooltip>
                        </span>
                        <div className="sso-field">
                            {!denyIfUnmatched && (
                                <Autocomplete
                                    className="autocompleteText"
                                    fullWidth
                                    multiple
                                    limitTags={2}
                                    size="small"
                                    value={templateName}
                                    options={filteredTemplateNames}
                                    getOptionLabel={(option: any) => option}
                                    isOptionEqualToValue={(option, value) => option === value}
                                    getOptionDisabled={(opt) => isTemplateOptionDisabled(opt, templateName)}
                                    disabled={isReadOnly}
                                    onChange={(_e, newValue: any) => {
                                        setTemplateName(newValue);
                                        clearValidationError("defaultPolicy");
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params} placeholder="Select Access Level" />
                                    )}
                                />
                            )}
                            {validationErrors.defaultPolicy && <div className="sso-field-error">{validationErrors.defaultPolicy}</div>}
                            <div className="sso-deny-checkbox-row">
                                <Checkbox
                                    checked={denyIfUnmatched}
                                    onChange={(e) => {
                                        setDenyIfUnmatched(e.target.checked);
                                        if (e.target.checked) setTemplateName([]);
                                        clearValidationError("defaultPolicy");
                                    }}
                                    disabled={isReadOnly}
                                    size="small"
                                    className="sso-deny-checkbox"
                                />
                                <span className="sso-deny-label">Deny access if no group rule matches</span>
                                <Tooltip title="When enabled, SSO users whose IdP groups don't match any group mapping rule will be denied login. If disabled, the access level above is applied to all unmatched users.">
                                    <InfoOutlinedIcon className="sso-info-icon sso-deny-info" />
                                </Tooltip>
                            </div>
                        </div>
                    </div>

                    {/* Optional: Inactive Account Deletion */}
                    <div className="sso-form-row">
                        <span className="sso-label">
                            Inactive Account Deletion (days)
                            <Tooltip title="SSO users will be automatically removed from the system after this number of days of inactivity since their last login.">
                                <InfoOutlinedIcon className="sso-info-icon" />
                            </Tooltip>
                        </span>
                        <div className="sso-field">
                            <TextField
                                size="small"
                                variant="outlined"
                                type="number"
                                InputProps={{ inputProps: { min: 1, max: 365 } }}
                                value={ssoPurgeInterval}
                                onChange={handlePurgeIntervalChange}
                                sx={{ width: "120px" }}
                                disabled={isReadOnly}
                            />
                        </div>
                    </div>

                    {/* Optional: Allow sub-organizations to use this SSO */}
                    <div className="sso-form-row" style={{ alignItems: "center" }}>
                        <span className="sso-label">
                            Allow sub-organizations to use this SSO
                            <Tooltip title="When enabled, sub-organizations that don't have their own SSO configured will automatically inherit this SSO configuration. Each sub-organization can still override it by setting up their own SSO.">
                                <InfoOutlinedIcon className="sso-info-icon" />
                            </Tooltip>
                        </span>
                        <div className="sso-field">
                            <Switch
                                checked={ssoInheritToSubDp}
                                onChange={(e) => setSsoInheritToSubDp(e.target.checked)}
                                disabled={isReadOnly}
                            />
                        </div>
                    </div>

                    {/* User Attributes - always visible in Step 2 */}
                    <div className="sso-form-row">
                        <span className="sso-label">
                            User Attributes
                            <Tooltip title="Optional attribute statements your Identity Provider sends alongside the user's identity. Configure these so the platform can display profile fields and, if group role mapping is set, resolve role assignments.">
                                <InfoOutlinedIcon className="sso-info-icon" />
                            </Tooltip>
                        </span>
                        <div className="sso-field sso-attributes-field">
                            <span className="sso-attribute-names">
                                <code>FirstName</code>
                                <code>LastName</code>
                                <code>Groups</code>
                            </span>
                            <Button
                                size="small"
                                className="sso-group-mapping-guide-btn"
                                startIcon={<HelpOutlineIcon />}
                                onClick={() => setUserAttributeGuideOpen(true)}
                            >
                                How to configure
                            </Button>
                        </div>
                    </div>

                    {/* Action Buttons */}
                    <div className="sso-settings-buttons">
                        <div>
                            {isConfigured && isEditing && (
                                <Button className="sso-clear-button" onClick={handleClear}>
                                    Clear
                                </Button>
                            )}
                        </div>
                        <div className="sso-settings-buttons-right">
                            {isConfigured && !isEditing && (
                                <Button className="sso-edit-button" onClick={handleEdit}>
                                    Edit
                                </Button>
                            )}
                            {isConfigured && isEditing && (
                                <Button className="sso-cancel-button" onClick={handleCancel}>
                                    Cancel
                                </Button>
                            )}
                            {(!isConfigured || isEditing) && (
                                <Button className="sso-save-button" onClick={handleSave}>
                                    {isConfigured ? "Update" : "Save"}
                                </Button>
                            )}
                        </div>
                    </div>
                </div>
            </Grid>

            <ConfirmDialog confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog} />

            <Dialog
                open={userAttributeGuideOpen}
                onClose={() => setUserAttributeGuideOpen(false)}
                maxWidth="sm"
                fullWidth
                className="sso-guide-dialog"
            >
                <DialogTitle className="sso-guide-dialog-title">
                    <span>User Attribute Configuration</span>
                    <IconButton size="small" onClick={() => setUserAttributeGuideOpen(false)}>
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </DialogTitle>
                <DialogContent className="sso-guide-dialog-content">
                    <p className="sso-guide-intro">
                        Configure your Identity Provider to send the attributes below so the platform can populate
                        user profile fields{groupRoleMapping.some(m => m.idpGroup?.trim()) ? " and resolve group-based role assignments" : ""}.
                        Names are case-sensitive.
                    </p>

                    <div className="sso-guide-provider">
                        <div className="sso-guide-provider-header">
                            <OktaIcon />
                            <span>Okta</span>
                        </div>
                        <ol className="sso-guide-steps">
                            <li>In the Okta Admin Console, go to <strong>Applications</strong> and open your SAML application.</li>
                            <li>Open the <strong>Sign On</strong> tab.</li>
                            <li>Scroll down to the <strong>Attribute Statements</strong> section.</li>
                            <li>
                                Click <strong>Add Expression</strong> and add each of the following Name / Expression pairs:
                                <div className="sso-guide-attr-list">
                                    {[
                                        { name: "FirstName", expression: "user.profile.firstName" },
                                        { name: "LastName", expression: "user.profile.lastName" },
                                        { name: "Groups", expression: "user.getGroups({'group.profile.name': '.*.*'}).![profile.name]" },
                                    ].map(({ name, expression }) => (
                                        <div className="sso-guide-attr-item" key={name}>
                                            <div className="sso-guide-attr-row">
                                                <span className="sso-guide-attr-label">Name</span>
                                                <code className="sso-guide-attr-value">{name}</code>
                                                <Tooltip title="Copy">
                                                    <IconButton size="small" className="sso-guide-copy-btn" onClick={() => handleCopyToClipboard(name)}>
                                                        <ContentCopyIcon fontSize="inherit" />
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                            <div className="sso-guide-attr-row">
                                                <span className="sso-guide-attr-label">Expression</span>
                                                <code className="sso-guide-attr-value">{expression}</code>
                                                <Tooltip title="Copy">
                                                    <IconButton size="small" className="sso-guide-copy-btn" onClick={() => handleCopyToClipboard(expression)}>
                                                        <ContentCopyIcon fontSize="inherit" />
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </li>
                            <li>Click <strong>Save</strong>.</li>
                        </ol>
                        <p className="sso-guide-note">
                            <strong>Note:</strong> The <code>.*.*</code> regex sends every group the user belongs to and the
                            <code>.![profile.name]</code> projection extracts each group's name so the SAML assertion receives a list of names
                            instead of group objects. Replace the regex with a narrower pattern (for example <code>^k4-.*</code>) to limit the
                            assertion to a specific prefix of groups.
                        </p>
                        <a
                            className="sso-guide-doc-link"
                            href="https://help.okta.com/oie/en-us/content/topics/apps/federated-claims-overview.htm?cshid=federated-claims-overview"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Okta documentation: Configure custom claims for app integrations <OpenInNewIcon className="sso-guide-doc-link-icon" />
                        </a>
                    </div>

                    <div className="sso-guide-provider">
                        <div className="sso-guide-provider-header">
                            <AzureIcon />
                            <span>Azure AD / Entra ID</span>
                        </div>
                        <ol className="sso-guide-steps">
                            <li>In the Azure portal, go to <strong>Microsoft Entra ID &gt; Enterprise applications</strong> and select your application.</li>
                            <li>Under <strong>Manage</strong>, click <strong>Single sign-on</strong>.</li>
                            <li>In the <strong>Attributes &amp; Claims</strong> section, click <strong>Edit</strong>.</li>
                            <li>
                                Verify the following claims are present under <strong>Additional claims</strong>:
                                <table className="sso-guide-table">
                                    <thead>
                                        <tr><th>Claim name</th><th>Value</th></tr>
                                    </thead>
                                    <tbody>
                                        <tr><td><code>http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname</code></td><td><code>user.givenname</code></td></tr>
                                        <tr><td><code>http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname</code></td><td><code>user.surname</code></td></tr>
                                    </tbody>
                                </table>
                                If not present, click <strong>Add new claim</strong> and add them.
                            </li>
                            <li>
                                Add a <strong>Group claim</strong>:
                                <ul>
                                    <li>Click <strong>Add a group claim</strong>.</li>
                                    <li>Select <strong>Groups assigned to the application</strong> (recommended).</li>
                                    <li>Under <strong>Source attribute</strong>, pick <strong>Cloud-only group display names</strong> so Azure sends names instead of object IDs.</li>
                                    <li>Click <strong>Save</strong> and verify the claim name is <code>Groups</code>.</li>
                                </ul>
                            </li>
                            <li>Click <strong>Save</strong>.</li>
                        </ol>
                        <a
                            className="sso-guide-doc-link"
                            href="https://learn.microsoft.com/en-us/entra/identity-platform/saml-claims-customization"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Microsoft documentation: Customize SAML token claims <OpenInNewIcon className="sso-guide-doc-link-icon" />
                        </a>
                    </div>
                </DialogContent>
            </Dialog>

            {authReducer.loading ? (
                <CustomLoader
                    showLoader={showLoader}
                    loadingText={loaderMessage}
                />
            ) : null}
        </Grid>
    );
};

const mapStateToProps = (state) => ({
    authReducer: state.authReducer,
    errorReducer: state.errorReducer,
    selectedOu: state.authReducer.selectedOu,
    groupSettingsdata: state.authReducer.getGroupSettingsData,
    saveSSOConfigData: state.authReducer.saveSSOConfig,
    updateSSOConfigData: state.authReducer.updateSSOConfig,
    deleteSSOConfigData: state.authReducer.deleteSSOConfig,
    verifySSOConnectionData: state.authReducer.verifySSOConnection,
    setSSOCodeData: state.authReducer.setSSOCode,
    tosAccepted: state?.starlinkToS?.tosAccepted,
});

export default withRouter(
    connect(mapStateToProps, {
        getGroupSettingsData,
        saveSSOConfig,
        updateSSOConfig,
        deleteSSOConfig,
        verifySSOConnection,
        setSSOCode,
        allTemplate,
        fetchStarlinkTosValidation,
    })(SSOSettings)
);
